import React from 'react'
import { WrapWarningCell } from './Style'
import { deviationRatingIndex, naLabel, ratingListLabel, ratingListTheme } from 'keys/rating'
import { SvgIcon, Tooltip } from '@mui/material'
import { statuses } from 'keys'
import { ReactComponent as CheckIcon } from 'assets/icons/Check.svg';
import { ReactComponent as SpinnerIcon } from 'assets/icons/Spinner.svg';
import { Chip } from 'components/Form'

const AssessmentExecutionCell = (props) => {
    const
        { row } = props,
        { execution_assessment_count, total_assessment_count } = row.original

    const { complete, inProgress } = statuses

    const statusConfig = {
        [complete]: {
            label: "הושלם",
            icon: <SvgIcon fontSize='10' component={CheckIcon} inheritViewBox />,
            color: "green8"
        },
        [inProgress]: {
            label: "מחכה לביצוע",
            color: "orange",
            icon: <SvgIcon fontSize='10' component={SpinnerIcon} inheritViewBox />
        }
    }

    const statusConfigItem =
        (execution_assessment_count < total_assessment_count && total_assessment_count) ?
            statusConfig[inProgress] :
            statusConfig[complete]

    return (
        <div style={{ display: "flex" }}>
            <Chip color={statusConfigItem.color}>
                {statusConfigItem.icon}
                <span>
                    {statusConfigItem.label}
                </span>
                <span>
                    {execution_assessment_count}/{total_assessment_count}
                </span>
            </Chip>
        </div>
    )
}

export default AssessmentExecutionCell